var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-container"},[_c('div',{staticClass:"main2",staticStyle:{"margin-top":"-5px"}},[_c('el-table',{staticStyle:{"width":"100%","border-left":"1px solid #e7e6e4"},attrs:{"data":_vm.userInfo,"cell-style":{
        'text-align': 'center',
        'border-color': '#dbdbdb',
        position: 'relative',
        'background-color': '#fff',
        'border-right': '1px solid #e7e6e4',
      },"header-cell-style":{
        'background-color': '#b6b6b6',
        color: '#000',
        fontSize: '14px',
        fontWeight: '300',
        'text-align': 'center',
      }}},[_c('el-table-column',{attrs:{"prop":"customerName","label":"用户名","width":"100"}}),_c('el-table-column',{attrs:{"prop":"companyName","label":"公司名称","width":"160"}}),_c('el-table-column',{attrs:{"prop":"linkman","label":"姓名"}}),_c('el-table-column',{attrs:{"prop":"--","label":"财务"}}),_c('el-table-column',{attrs:{"prop":"employeeName","label":"销售员"}}),_c('el-table-column',{attrs:{"prop":"--","label":"采购"}}),_c('el-table-column',{attrs:{"prop":"--","label":"邮箱"}}),_c('el-table-column',{attrs:{"prop":"companyName","label":"关联公司"}}),_c('el-table-column',{attrs:{"prop":"phone","label":"电话"}}),_c('el-table-column',{attrs:{"prop":"linkAddress","label":"经营地址"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }